import React, { useEffect, useState, useContext } from 'react';
import { Table } from 'antd';
import * as Setting from '../utils/AuthUtils';
import AddLeague from '../components/AddLeague';
import { leagueCols } from '../utils/DataUtils';
import { wsBaseHref } from '../AppConfig';
import { MeContext } from '../context';
import { motion } from 'motion/react';

function Leagues() {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false)
    const [items, setItems] = useState([]);
    const me = useContext(MeContext);

    useEffect(() => {
      const isAd = (me && me.payLoad ? me.payLoad.isAdmin : false)
      setIsAdmin(isAd);
      fetch(wsBaseHref+"/leagues")
        .then(res => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            let fltrRes = result.payLoad.filter(function( obj ) {
              return obj.leagueName !== 'LPI';
            });
            setItems(fltrRes);
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
      }, [me])
      
      return (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
        <h1>
            Leagues
        </h1>
        <Table
            columns={leagueCols} 
            dataSource={items} 
            pagination={false} 
            loading={!isLoaded}/>
        { Setting.isLoggedIn() && isAdmin && 
          <AddLeague />
        }
        </motion.div>
    );
}

export default Leagues;